import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import HistoryIcon from '@mui/icons-material/History';
import RuleIcon from '@mui/icons-material/Rule';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { SideTabSection } from '../../../components/SideTabs';

export type PremiumSection = 'compare' | 'totals' | 'robo' | 'groups' | 'services' | 'unassigned' | 'history';

export const DEFAULT_PREMIUM_SECTION: PremiumSection = 'compare';

/** Section tabs of the Premium tab, in this order. value = param = the `?premiumTab=` query value. */
export const premiumTabSections: SideTabSection[] = [
  {
    title: 'Overview',
    tabs: [{ value: 'compare', param: 'compare', label: 'Compare plans', IconComponent: CompareArrowsIcon }],
  },
  {
    title: 'Rules',
    tabs: [
      { value: 'totals', param: 'totals', label: 'Plan totals', IconComponent: TuneIcon },
      { value: 'robo', param: 'robo', label: 'Robo Advice', IconComponent: SmartToyOutlinedIcon },
      { value: 'groups', param: 'groups', label: 'Product groups', IconComponent: RuleIcon },
      { value: 'services', param: 'services', label: 'Services', IconComponent: WidgetsOutlinedIcon },
    ],
  },
  {
    title: 'Checks',
    tabs: [
      {
        value: 'unassigned',
        param: 'unassigned',
        label: 'Products without a group',
        IconComponent: ReportProblemOutlinedIcon,
      },
      { value: 'history', param: 'history', label: 'Change history', IconComponent: HistoryIcon },
    ],
  },
];
